export const CATEGORY_OPTIONS = ["", "vegetables", "fruits", "grains", "livestock"] as const;
